export function isRoot(fullPath: string): boolean {
  return fullPath.split('/').length === 1;
}
